import React from 'react'
import { UIBadge, type UIBadgeProps } from './ui-badge'

export interface UIBadgeOutlineProps extends Omit<UIBadgeProps, 'variant' | 'children'> {
  children?: React.ReactNode
}

/**
 * UIBadgeOutline - Outline Badge Block
 * 아웃라인 스타일의 배지 컴포넌트입니다.
 * 아웃라인 스타일의 배지입니다.
 */
export const UIBadgeOutline = React.forwardRef<HTMLSpanElement, UIBadgeOutlineProps>(
  ({ children = "Outline", ...props }, ref) => {
    return (
      <UIBadge
        ref={ref}
        variant="outline"
        {...props}
      >
        {children}
      </UIBadge>
    )
  }
)

UIBadgeOutline.displayName = "UIBadgeOutline"